export default __webpack_public_path__ + "static/media/regenesis-logo.b4bb0011.png";